import { createStyles, makeStyles } from '@mui/styles';
import { ReactElement } from 'react';

import { Button, Theme } from '@mui/material';

import { DeprecatedBaseHeaderProps } from '@localstack/types';

import { AwsAccountField, AwsRegionDropdown } from '@localstack/ui';

import { DeprecatedBaseHeader } from './DeprecatedBaseHeader';

interface ResourceBrowserHeaderProps extends DeprecatedBaseHeaderProps {
  /** reset function to call on Reset Form Button */
  resetFn: (() => void) | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    regionDivider: {
      borderLeft: 'solid 1px',
      width: 0,
      height: '2em',
      borderColor: theme.palette.divider,
    },
  }),
);

export const ResourceBrowserHeader = ({ actions, resetFn, ...rest }: ResourceBrowserHeaderProps): ReactElement => {
  const classes = useStyles();
  return (
    <DeprecatedBaseHeader
      actions={
        <>
          {resetFn && (
            <Button variant="outlined" onClick={() => resetFn?.()}>
              Reset Form
            </Button>
          )}
          {actions}
          <div className={classes.regionDivider} />
          <AwsRegionDropdown />
          <AwsAccountField />
        </>
      }
      {...rest}
    />
  );
};
